import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from '@mui/material';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import { useTranslation } from 'react-i18next';
import { baseCell, DataGridLinkCell, dateCell } from 'components/cells';
import { ConfirmationDeleteTableDialog } from 'components/ui/feedback';

export function TransportActiveDocumentLinesColumns(
  isStatusNew: boolean,
  handleDelete?: any,
  handleEdit?: (id: number) => void,
  handleOpenInfoDialog?: any,
  disableEdit?: boolean,
  isClosed?: boolean,
  isSupplierDdt?: boolean
): GridColDef[] {
  const translationPrefix = 'pages.active-ddt.product-list';
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'quantity',
      headerName: t(`${translationPrefix}.quantity`),
      width: 80,
      type: 'number',
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'product_code',
      headerName: t(`${translationPrefix}.product_code`),
      width: 175,
      filterable: false,
      renderCell: (params) => (
        <DataGridLinkCell params={params} basePath="tenant/products" idKey="product" />
      )
    },
    {
      field: 'product_description',
      headerName: t(`${translationPrefix}.product_description`),
      width: 250,
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'order_code',
      headerName: t(`${translationPrefix}.order`),
      width: 125,
      filterable: false,
      renderCell: useIsTenantAdministrator()
        ? (params) => (
            <DataGridLinkCell params={params} basePath="tenant/orders/view" idKey="order_id" />
          )
        : baseCell
    },
    {
      field: 'product_batch',
      headerName: t(`${translationPrefix}.product_batch`),
      width: 100,
      filterable: false,
      renderCell: baseCell
    },
    {
      field: 'expiration_date',
      headerName: t(`${translationPrefix}.expiration_date`),
      width: 100,
      filterable: false,
      renderCell: dateCell
    },
    {
      field: 'notes',
      headerName: t(`${translationPrefix}.notes`),
      filterable: false,
      width: 250,
      renderCell: baseCell
    },
    ...(!isSupplierDdt
      ? [
          {
            field: 'expected_order_quantity',
            headerName: t(`${translationPrefix}.sent_not_arrived_packages`),
            width: 140,
            type: 'number',
            filterable: false,
            renderCell: baseCell
          },
          {
            field: 'sent_not_arrived_quantity',
            headerName: t(`${translationPrefix}.sent_not_arrived_quantity`),
            width: 160,
            type: 'number',
            filterable: false,
            renderCell: baseCell
          },
          {
            field: 'not_sent_quantity',
            headerName: t(`${translationPrefix}.not_sent_quantity`),
            width: 140,
            type: 'number',
            filterable: false,
            renderCell: baseCell
          }
        ]
      : [])
  ];

  if (isStatusNew && !disableEdit && !isClosed) {
    columns.push({
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => [
        <Tooltip title={t('actions.edit')} key={1}>
          <IconButton onClick={() => handleEdit(params.row)}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>,
        <ConfirmationDeleteTableDialog
          key={2}
          handleDelete={handleDelete}
          id={params.row.id}
          tag={false}
        />
      ]
    } as GridColDef);
  }

  return columns;
}
